// This directive disables no-restricted-syntax to allow for a deliberate assignment to innerHTML
// This is allowed because formatTextForSlack thoroughly escapes HTML.
const format = (el, binding) => {
  // .collapseWhitespace skips .display (pre-wrap), for compact previews that should render on one line.
  // It's a rendering option, not a formatter one, so it's kept out of formatTextForSlack's args.
  const { collapseWhitespace, ...formatterArgs } = binding.modifiers;
  if (!collapseWhitespace) el.classList.add('display');
  // eslint-disable-next-line no-restricted-syntax
  el.innerHTML = Donut.Formatter.formatTextForSlack(binding.value, formatterArgs);
};

export default {
  mounted(el, binding, vnode) {
    format(el, binding, vnode);
  },

  updated(el, binding, vnode) {
    if (binding.oldValue !== binding.value) {
      format(el, binding, vnode);
    }
  },
};
